import { z } from 'zod';

// Define the JudgedResponse schema
export const JudgedResponseSchema = z.object({
    response_id: z.string(),
    points: z.number(),
});

// Define the Judge schema
export const JudgeSchema = z.object({
    PK: z.string(),
    SK: z.string(),
    pnts_remaining: z.number(),
    judged_responses: z.array(JudgedResponseSchema),
    created_at: z.number(),
});

// Infer the TypeScript types from the schemas
export type JudgedResponse = z.infer<typeof JudgedResponseSchema>;
export type Judge = z.infer<typeof JudgeSchema>;
